import api from '../utils/api';
import { getEnovaMeetingLink, parseGuestEmails } from '../utils/dashboardUtils';

export const fetchMeetings = async () => {
    const response = await api.get('/collab-meetings/meetings');
    return response.data;
};

export const fetchMeeting = async (id) => {
    const response = await api.get(`/collab-meetings/meeting/${id}`);
    return response.data;
};

export const fetchGuestMeeting = async (cleanId) => {
    const response = await api.get(`/collab-meetings/guest-meeting/${cleanId}`);
    return response.data;
};

export const scheduleMeeting = async (payload) => {
    const response = await api.post('/collab-meetings/schedule', payload);
    return response.data;
};

export const updateMeeting = async (id, data) => {
    const response = await api.put(`/collab-meetings/meeting/${id}`, data);
    return response.data;
};

export const deleteMeeting = async (id) => {
    const response = await api.delete(`/collab-meetings/meeting/${id}`);
    return response.data;
};

export const endMeeting = async (id) => {
    const response = await api.post(`/collab-meetings/meeting/${id}/end`);
    return response.data;
};

export const guestJoin = async (data) => {
    const response = await api.post('/collab-meetings/guest-join', data);
    return response.data;
};

export const fetchParticipants = async (id) => {
    const response = await api.get(`/collab-meetings/meeting/${id}/participants`);
    return response.data;
};

export const fetchAttendance = async (id) => {
    const response = await api.get(`/collab-meetings/meeting/${id}/participants?all=1`);
    return response.data;
};

export const sendEmailInvite = async (data) => {
    const response = await api.post('/collab-meetings/send-email-invite', data);
    return response.data;
};

export const fetchEmployees = async () => {
    const response = await api.get('/collab-meetings/employees');
    return response.data;
};

export const fetchCustomers = async () => {
    const response = await api.get('/collab-meetings/customers');
    return response.data;
};

export const fetchSpaces = async () => {
    const response = await api.get('/collab-meetings/spaces');
    return response.data;
};

export const sendMeetingInviteEmails = async ({ meetingId, title, employeeIds = [], guestEmails = [], meetingLink = null, allEmployeesList = [], currentUser = null }) => {
    if (!meetingId) return { successCount: 0, failCount: 0, total: 0 };

    const link = meetingLink || getEnovaMeetingLink(meetingId);
    const emails = [];

    (employeeIds || []).forEach((id) => {
        const emp = allEmployeesList.find((e) => String(e.user_id) === String(id));
        if (emp?.email && emp.email.includes('@')) {
            emails.push(emp.email.trim());
        }
    });

    parseGuestEmails(guestEmails).forEach((email) => emails.push(email));

    const uniqueEmails = [...new Set(emails.map((e) => e.toLowerCase()))].map((lower) =>
        emails.find((e) => e.toLowerCase() === lower)
    ).filter(Boolean);

    if (uniqueEmails.length === 0) {
        return { successCount: 0, failCount: 0, total: 0 };
    }

    try {
        const responseData = await sendEmailInvite({
            to: uniqueEmails,
            subject: `Meeting Invitation: ${title || 'Collaboration Room'}`,
            body: `Hello,\n\nYou have been invited to a meeting${title ? `: ${title}` : ''}.\n\nPlease join using the following link:\n${link}\n\nBest regards,\n${currentUser?.name || 'Your Team'}`
        });

        if (responseData && responseData.status === 'success') {
            return {
                successCount: responseData.success_count ?? uniqueEmails.length,
                failCount: responseData.fail_count ?? 0,
                total: uniqueEmails.length,
                message: responseData.message
            };
        }

        return {
            successCount: 0,
            failCount: uniqueEmails.length,
            total: uniqueEmails.length,
            message: responseData?.message || 'Failed to send invite emails.'
        };
    } catch (err) {
        console.error('Failed to send meeting invites', err);
        return {
            successCount: 0,
            failCount: uniqueEmails.length,
            total: uniqueEmails.length,
            message: err.response?.data?.message || 'Failed to send invite emails.'
        };
    }
};
